import { getFrontMessage } from 'appMessageDefinitions';
import { UsecaseIntroMessages } from './usecasePageTypes';
import { useMemo } from 'react';
import { UsecaseName } from '../../appConstantsUsecase';
import { ShIntlMessageDefinition } from '@shoootin/translations';

const UsecasePrefix = 'front_usecase';

export const getUsecaseMessage = (
  category: string, //TODO type
  key: string, //TODO type
  usecase: UsecaseName,
): ShIntlMessageDefinition =>
  //@ts-ignore
  getFrontMessage(`${UsecasePrefix}_${category}_${usecase}_${key}`);

export const getUsecaseTimelineCaption = (
  category: string,
  key: string,
  usecase: UsecaseName,
  i: number,
): ShIntlMessageDefinition =>
  //@ts-ignore
  getFrontMessage(`${UsecasePrefix}_${category}_${usecase}_${key}_${i}`);

const getIntroMessages = (usecase: UsecaseName): UsecaseIntroMessages => {
  const getMessage = (key: string) =>
    getUsecaseMessage('UsecaseIntro', key, usecase);
  return {
    title: getMessage('title'),
    subtitle: getMessage('subtitle'),
    introQuote: getMessage('introQuote'),
    userRole: getMessage('userRole'),
  };
};

export const useIntroMessages = (usecase: UsecaseName): UsecaseIntroMessages =>
  useMemo(() => getIntroMessages(usecase), [usecase]);
